import React, { useState, useEffect } from "react";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

const ReviewSlider = ({ product }) => {
  const [start, setStart] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);

  const reviews = product?.review || [];
  const avgRating = Number(product?.ratestar) || 0;

  // ⭐ Amazon Style Stars
  const renderStars = (rating) => {
    const stars = [];

    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        stars.push(<FaStar key={i} />);
      } else if (rating >= i - 0.5) {
        stars.push(<FaStarHalfAlt key={i} />);
      } else {
        stars.push(<FaRegStar key={i} />);
      }
    }

    return (
      <div className="flex items-center text-[#FFA41C] text-sm gap-[2px]">
        {stars}
      </div>
    );
  };

  // Responsive
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) setVisibleCount(1);
      else if (window.innerWidth < 1024) setVisibleCount(2);
      else setVisibleCount(3);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto Slide
  useEffect(() => {
    if (!reviews.length) return;

    const interval = setInterval(() => {
      setStart((prev) =>
        prev + 1 >= reviews.length ? 0 : prev + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [reviews]);

  if (!product) {
    return <div className="text-center py-10">Loading...</div>;
  }

  if (!reviews.length) {
    return (
      <div className="text-center py-16 text-gray-500">
        No Reviews Yet
      </div>
    );
  }

  // Visible Reviews
  const visibleReviews = [];
  for (let i = 0; i < visibleCount; i++) {
    visibleReviews.push(
      reviews[(start + i) % reviews.length]
    );
  }

  return (
    <section className="py-16 mt-5">
      <div className="max-w-7xl mx-auto px-4">

        {/* Heading */}
       
          <h2 className="text-3xl font-bold text-center mb-10">
  💬 What Our Customer Says
</h2>
      

        {/* Top Section */}
        <div className="grid md:grid-cols-2 gap-6 mb-10">

          {/* ⭐ Average Rating */}
          <div className="bg-white rounded-xl border p-6">

            <div className="flex items-center justify-center gap-3">
              <span className="text-4xl font-bold text-[#187685]">
                {avgRating.toFixed(1)}
              </span>

              {renderStars(avgRating)}
            </div>

            <p className="text-gray-500 text-sm text-center mt-2">
              {reviews.length} global ratings
            </p>
          </div>

          {/* 📊 Breakdown */}
          <div className="bg-white rounded-xl border p-6">
            {[5, 4, 3, 2, 1].map((star) => {
              const count = reviews.filter(
                (r) => Math.floor(Number(r.userstar)) === star
              ).length;

              const percent =
                reviews.length > 0
                  ? (count / reviews.length) * 100
                  : 0;

              return (
                <div key={star} className="flex items-center gap-3 mb-2">
                  <span className="text-sm w-12 text-[#187685] flex items-center gap-1">
                    {star}
                    <span className="text-[#FFA41C]">★</span>
                  </span>

                  <div className="flex-1 bg-gray-200 h-2 rounded">
                    <div
                      className="h-2 rounded bg-[#187685] transition-all duration-500"
                      style={{ width: `${percent}%` }}
                    ></div>
                  </div>

                  <span className="text-xs text-gray-500 w-6 text-right">
                    {count}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

        {/* 💬 Reviews */}
        <div className="grid md:grid-cols-3 gap-6">
          {visibleReviews.map((review, i) => (
            <div
              key={i}
              className="bg-white border rounded-xl p-5 hover:shadow-md transition"
            >
              {/* User */}
              <div className="flex items-center gap-3 mb-2">
                <div className="w-9 h-9 bg-[#187685] text-white rounded-full flex items-center justify-center text-sm font-bold">
                  {review.userName?.charAt(0)}
                </div>

                <p className="font-medium text-sm">
                  {review.userName}
                </p>
              </div>

              {/* ⭐ */}
              <div className="flex items-center gap-2">
                {renderStars(Number(review.userstar))}
                <span className="text-sm font-semibold">
                  {review.title || "Good product"}
                </span>
              </div>

              {/* Date */}
              <p className="text-xs text-gray-400 mt-1">
  {product.createdAt
    ? new Date(product.createdAt).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    : "Reviewed in India"}
</p>

              {/* Comment */}
              <p className="text-gray-700 text-sm mt-2">
                {review.comment}
              </p>

              {/* Verified */}
              <p className="text-xs text-[#187685] mt-2 font-medium">
                ✔ Verified Purchase
              </p>
            </div>
          ))}
        </div>

        {/* Buttons */}
        <div className="flex justify-center gap-4 mt-10">
          <button
            onClick={() =>
              setStart((prev) =>
                prev === 0 ? reviews.length - 1 : prev - 1
              )
            }
            className="px-5 py-2 border rounded-full"
          >
            Prev
          </button>

          <button
            onClick={() =>
              setStart((prev) =>
                prev + 1 >= reviews.length ? 0 : prev + 1
              )
            }
            className="px-5 py-2 text-white rounded-full"
            style={{ backgroundColor: "#187685" }}
          >
            Next
          </button>
        </div>

      </div>
    </section>
  );
};

export default ReviewSlider;